import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE, timeout: 90000 });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("mp_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const ACTIVITIES_PRIMARY = [
  "Sports",
  "Indoor Sports",
  "Billiard Games",
  "Board Games",
  "Video Games",
  "Dining",
  "Bars",
  "Clubs",
  "Beach",
  "Concerts",
  "Art & Crafts",
];

export const LANGUAGES = [
  { code: "en", name: "English", native: "English" },
  { code: "ar", name: "Arabic", native: "العربية" },
  { code: "es", name: "Spanish", native: "Español" },
  { code: "fr", name: "French", native: "Français" },
  { code: "hi", name: "Hindi", native: "हिन्दी" },
  { code: "ru", name: "Russian", native: "Русский" },
];
